export var TOOLTIP_POSITION = {
  TOP: 'top',
  BOTTOM: 'bottom'
};
export var TooltipAlignment;

(function (TooltipAlignment) {
  TooltipAlignment["Left"] = "left";
  TooltipAlignment["Center"] = "center";
  TooltipAlignment["Right"] = "right";
})(TooltipAlignment || (TooltipAlignment = {}));